import { Link } from 'react-router-dom';

const ChapterTwo = () => {


    return (
        <>
        <div className="knowledgetitle">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-md-12 col-lg-6">
                            <div className="page-tit">
                                <h1>knowledge Base</h1>
                            </div>
                        </div>

                        <div className="col-md-12 col-lg-6">
                            <div className="breadcrumb-page">
                                <ul>
                                    <li><Link to="/">Home</Link></li>
                                    <li>Chapter - Sub Optimal Pump Performance</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="pdf-sec mt-5 mb-5">
            <div className="container">
                <div className="row">
                    <div className="col-md-12">
                        <h4 className="text-center mb-3">Chapter - Sub Optimal Pump Performance</h4>
                        <div className="pdf-knowledge">
                            <img src='images/knowledge/chapter-sub-optimal.webp' />
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </>
    )
}

export default ChapterTwo;